import { OmvqVeterinarian } from '../types';
import { HydraQueryParams, useHydraQuery } from './useHydraQuery';

export function useGetOmvqVeterinariansQuery<D extends OmvqVeterinarian[]>(
  params?: HydraQueryParams<D>
) {
  const { vars, options, key } = params || {};

  return useHydraQuery<D>(
    key ?? `getOmvqVeterinariansQuery`,
    `/api/omvq_veterinarians?pagination=false`,
    {
      vars,
      options,
    }
  );
}
